import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Dialog from '@material-ui/core/Dialog'
import { messagesMongoQueries } from '../graphql/queries'
import { messagesMongoMutations } from '../graphql/mutations'
import DeleteButton from './DeleteButton'
import { Mutation } from 'react-apollo'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    '& > div': {
      overflow: 'inherit'
    }
  },
  content: {
    minHeight: 60,
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    '&, &:hover, &:focus': {
      width: 40,
      height: 40,
      marginLeft: 'auto'
    }
  },
  messageLink: {
    color: '#003884'
  }
})

class MessageDialogMongo extends React.Component {
  handleCancel = () => {
    this.props.onClose()
  }

  handleOk = () => {
    this.props.onClose()
  }

  renderMessage = () => {
    const { classes, message } = this.props

    const $messageDoc = document.createElement('div')
    $messageDoc.innerHTML = message.mensagem
    const contentLinks = $messageDoc.querySelectorAll('[data-content]')

    if (contentLinks.length) {
      for (let contentLink of contentLinks) {
        const contentURL = new URL(contentLink)

        contentLink.href = `conteudo${contentURL.pathname}`
        contentLink.className = classes.messageLink
      }
    }

    return (
      <div
        className={classes.container}
        dangerouslySetInnerHTML={{ __html: $messageDoc.innerHTML || '' }}
      />
    )
  }

  render() {
    const { classes, message,setMessage, onOpen, ...other } = this.props

    return (
      <Mutation
        mutation={messagesMongoMutations.REMOVE_MESSAGE_MONGO}
        update={(cache, { data: removeMessageMongo }) => {
          if (!removeMessageMongo) return
          const  {messagesMongoMutations} = cache.readQuery({
            query: messagesMongoQueries.GET_MESSAGES_MONGO
          })         
          cache.writeQuery({
            query: messagesMongoQueries.GET_MESSAGES_MONGO,
            data: {
              messages: messagesMongoMutations.filter(({ _id }) => _id !== message._id)
            }
          })
        }}
      >
        {(removeMessage, { data }) => {
          return (
            <Dialog
              maxWidth="xs"
              aria-labelledby="confirmation-dialog-title"
              className={classes.root}
              onEntered={onOpen}
              {...other}
            >
              <IconButton
                className={classes.closeButton}
                onClick={this.handleCancel}
                aria-label="Sair"
                color="gray"
              >
               <CloseIcon fontSize="small"/>
              </IconButton>
              <DialogTitle id="confirmation-dialog-title">{message.titulo}</DialogTitle>
              <DialogContent className={classes.content}>
                <Typography>
                  {this.renderMessage()}
                </Typography>
              </DialogContent>
              <DialogActions>
                <DeleteButton
                  time={3000}
                  callback={() => {

                    setMessage(message._id)
                    this.handleCancel()
                    removeMessage({
                      variables: {
                        id: message._id
                      },
                      optimisticResponse: {
                        __typename: 'Mutation',
                        removeMessage: true
                      }
                    })
                  }}
                />
              </DialogActions>
            </Dialog>
          )
        }}
      </Mutation>
    )
  }
}

export default withStyles(styles)(MessageDialogMongo)